import { render, staticRenderFns } from "./DocumentApprovalCreator.vue?vue&type=template&id=76aacfb9&scoped=true&"
import script from "./DocumentApprovalCreator.vue?vue&type=script&lang=js&"
export * from "./DocumentApprovalCreator.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApprovalCreator.vue?vue&type=style&index=0&id=76aacfb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aacfb9",
  null
  
)

export default component.exports